import { IMemberInteriorSettings } from "../../../models/interfaces/memberInteriorSettings/iMemberInteriorSettings";
import { MemberInteriorSettings } from "../../../models/classes/memberInteriorSettings/memberInteriorSettings";

export default class State {
  public settings: IMemberInteriorSettings = new MemberInteriorSettings();
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/memberInteriorSettings/state.ts